import { AuthResponse, LoginCredentials, RegisterData, User } from '../types';
import api from './api';

export const authService = {
    // Register new user
    register: async (data: RegisterData): Promise<AuthResponse> => {
        const response = await api.post<AuthResponse>('/auth/register', data);
        if (response.data.token) {
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('user', JSON.stringify(response.data.user));
        }
        return response.data;
    },

    // Login user
    login: async (credentials: LoginCredentials): Promise<AuthResponse> => {
        const response = await api.post<AuthResponse>('/auth/login', credentials);
        if (response.data.token) {
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('user', JSON.stringify(response.data.user));
        }
        return response.data;
    },

    // Logout user
    logout: () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
    },

    // Get current user from localStorage
    getCurrentUser: (): User | null => {
        const userStr = localStorage.getItem('user');
        if (userStr) {
            try {
                return JSON.parse(userStr);
            } catch (e) {
                return null;
            }
        }
        return null;
    },

    // Get current user token
    getToken: (): string | null => {
        return localStorage.getItem('token');
    },

    // Check if user is authenticated
    isAuthenticated: (): boolean => {
        return !!localStorage.getItem('token');
    },

    // Get user profile from API
    getProfile: async (): Promise<User> => {
        const response = await api.get<User>('/auth/profile');
        return response.data;
    },

    // Public: request a fresh verification email for an address. Always
    // resolves — the API never reveals whether the address has an account.
    resendVerificationByEmail: async (email: string): Promise<void> => {
        await api.post('/auth/resend-verification-by-email', { email });
    },

    // Public: request a password-reset email. Always resolves (anti-enumeration).
    requestPasswordReset: async (email: string): Promise<void> => {
        await api.post('/auth/request-password-reset', { email });
    },

    // Public: consume a reset token and set a new password.
    resetPassword: async (token: string, password: string): Promise<void> => {
        await api.post('/auth/reset-password', { token, password });
    },
};
